var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiFiletypeKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 14.625V45.5C45.5 47.2239 44.8152 48.8772 43.5962 50.0962C42.3772 51.3152 40.7239 52 39 52H35.75V48.75H39C39.862 48.75 40.6886 48.4076 41.2981 47.7981C41.9076 47.1886 42.25 46.362 42.25 45.5V14.625H35.75C34.4571 14.625 33.2171 14.1114 32.3029 13.1971C31.3886 12.2829 30.875 11.0429 30.875 9.75V3.25H13C12.138 3.25 11.3114 3.59241 10.7019 4.2019C10.0924 4.8114 9.75 5.63805 9.75 6.5V35.75H6.5V6.5C6.5 4.77609 7.18482 3.12279 8.40381 1.90381C9.62279 0.68482 11.2761 0 13 0L30.875 0L45.5 14.625ZM10.4325 38.5125H7.605L2.6975 44.33H2.5675V38.5125H0V51.5093H2.57075V47.3395L3.90325 45.825L7.54325 51.5093H10.634L5.798 44.1123L10.4358 38.5125H10.4325ZM19.8673 49.4065H14.0497V45.9193H19.526V43.9497H14.0497V40.6185H19.8673V38.5125H11.4985V51.5093H19.8673V49.4065ZM27.157 46.5205V51.5093H24.5765V46.5693L20.2248 38.5125H23.075L25.8472 44.0245H25.9513L28.73 38.5125H31.512L27.1603 46.5205H27.157Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiFiletypeKey);
export default __webpack_public_path__ + "static/media/bi_filetype-key.80b1ebdca813afe4a5b78915d5f786d3.svg";
export { ForwardRef as ReactComponent };